import {
  ELT_FORM_SECTION,
  IMeetingSummary,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { useTranslation } from 'react-i18next'

import { Textarea } from 'core-components/library/inputs'

import { getFormedEltTranslation } from '../../../helpers/getFormedEltTranslation'
import { translationReplacer } from '../../../helpers/translationReplacer'
import { ForceUpdate } from '../../styledComponents/forceUpdate/ForceUpdate'
import { Title } from '../../styledComponents/title/Title'

import styles from './MeetingSummary.module.scss'

interface IProps {
  data: IMeetingSummary
  updateFormData: (field: string) => (value: string) => void
  forceUpdate: (section: ELT_FORM_SECTION) => void
  formIsFinalized: boolean
}

export const MeetingSummary = ({ data, updateFormData, forceUpdate, formIsFinalized }: IProps) => {
  const [t] = useTranslation()

  return (
    <div className={styles.root}>
      <Title
        variant="withBackground"
        text={getFormedEltTranslation('section-meeting-summary')}
        rightContent={
          <ForceUpdate isIcon onClick={forceUpdate} section={ELT_FORM_SECTION.MEETING_SUMMARY} />
        }
      />
      <RenderWhen condition={!formIsFinalized}>
        <Textarea
          placeholder={translationReplacer(getFormedEltTranslation('company-bio'), t)}
          rows={6}
          value={data.Bio}
          onChange={updateFormData('Bio')}
        />
      </RenderWhen>
      <RenderWhen condition={formIsFinalized}>
        <div className={styles.fixHeight}>{data.Bio}</div>
      </RenderWhen>
    </div>
  )
}
